<script setup lang="ts">
import type { PersonRelation } from "~/types/article"
import { formatYearRange } from "~/utilities/format"

defineProps<{ note: PersonRelation }>()
</script>

<template>
  <USidenote :note="note" title-class="text-dark-blue-dark">
    <template #sidenoteType>
      <span>
        | ({{
          formatYearRange(
            note.resource.birthYear,
            note.resource.deceasedYear,
          )
        }})</span>
    </template>
    <template #content>
      <div v-html="note.resource.about" />
    </template>
  </USidenote>
</template>
